<template>
    <div class="content">
        <!-- 查询和其他操作 -->
        <div class="search_bar">
            <div class="search_bar_item">
                <Button  width="100%" icon="ios-add" type="primary" @click="addGrouping('isAdd')">添加</Button>
            </div>
        </div>

        <div class="table_wrap">
            <div style="width:100%">
                <Table   stripe border ref="table" 
                    :height="tableHeight"
                    :loading="tabLoading" 
                    :columns="tabColumns" 
                    :data="tabData">
                </Table>
                <div style="margin-top:20px;display:flex;justify-content:flex-end">
                    <Page show-total show-elevator show-sizer  :page-size-opts="pageSizeOpts" :page-size="50"
                        :total="total"  :current="listQuery.page"
                        :transfer="true"
                        @on-change="changePage" 
                        @on-page-size-change="changeLimit"/>
                </div>
            </div>
        </div>

         <!-- 添加|编辑渠道对话框 -->
        <Modal
            v-model="showAddGrouping"
            :closable="false"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header" class="modal_title">
                    <span>{{isTitle}}</span>
                </p>
                <Form  ref="addGroupingForm" :model="addGroupingForm" :rules="addChannelFormRule" :label-width="80" >
                    <FormItem label="名称" prop="name">
                        <Input v-model="addGroupingForm.name" style="width:90%"   placeholder="请输入分组名称"></Input>
                    </FormItem>
                    <FormItem label="排序" prop="sort">
                        <Input v-model="addGroupingForm.sort" type="number" 
                        :change="check_num()"
                        style="width:90%"   placeholder="请输入排序"></Input>
                    </FormItem>  
                    <FormItem label="备注" prop="remark">
                        <Input v-model="addGroupingForm.remark" style="width:90%"  type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
                    </FormItem>         
                </Form>

                <div slot="footer">
                    <Button type="primary" size="large"  @click="handleSubmit('addGroupingForm',isTitle)">确定</Button>
                    <Button  size="large"  @click="handleReset('addGroupingForm')">取消</Button>
                </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:'groupingManagement',
    data(){
        return{
            storeList:[],
            departmentList:[],
            channelTagList:[],
            showAddGrouping:false,  
            tableHeight:650,
            tabLoading:false,
            tabData:[],
            tabColumns: [
                    {
                        title: '名称',
                        key: 'name',
                        align:'center'
                    },
                    {
                        title: '排序',
                        key: 'sort',
                        align:'center'
                    },
                    {
                        title: '操作',
                        // width: 200,
                        align: 'center',
                        render: (h, params) => {
                            // console.log('操作params',params)
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.addGrouping(params.row.id)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.apiDeleteGrouping(params.row)
                                        }
                                    }
                                }, '删除')
                            ]);  
                        }
                    }
                ],
           
            // 列表查询参数
            listQuery:{
                page:1,
                limit:50,
            },
            total:0,
            pageSizeOpts:[50,60,70,80,90,100],
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            },
            stylesModal:{
                height: '500px',
                overflow: 'auto',
                // position: 'static'
            },

            isTitle:'添加分组',
            isEditorGroupingId:'',
            addGroupingForm:{
                name:'',
                sort:'',
                remark:''
            },
           

            addChannelFormRule:{
                name: [
                    { required: true, message: '请输入渠道名称', trigger: 'blur' }
                ],
                sort: [
                    { required: true, message: '请输入排序', trigger: 'blur'}
                ],
               
                remark:[
                    { required: true, message: '请输入', trigger: 'blur' },
                    { type: 'string', max: 100, message: '备注不能大于100字', trigger: 'blur' }
                ],
            }
        }
    },
    created(){
        this.getList()
    },
    mounted() {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220
    },
    methods:{
        // 分组详情
        apiDetailsGrouping(id){
            serve.fetchGet(api.crmMemberGroup+'/'+id,{}).then(res => {
                this.addGroupingForm.name=res.member_group.name
                this.addGroupingForm.sort=res.member_group.sort.toString()
                this.addGroupingForm.remark=res.member_group.remark
                this.showAddGrouping=true
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
       
        // 删除分组
        apiDeleteGrouping(param){
            serve.fetchDelete(api.crmMemberGroup+"/"+param.id,{}).then(res => {
                this.$Message.success('删除成功');
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 修改分组
        apiEditorGrouping(){
            serve.fetchPut(api.crmMemberGroup+"/"+this.isEditorGroupingId,this.addGroupingForm).then(res => {
                this.$Message.success('修改成功');
                this.showAddGrouping=false
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //  添加分组
        apiAddGrouping(){
            serve.fetchPost(api.crmMemberGroup,this.addGroupingForm).then(res => {
                this.$Message.success('添加成功');
                this.showAddGrouping=false
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },

        // 获取列表
        getList(){
            this.tabLoading=true
            serve.fetchGet(api.crmMemberGroup,this.listQuery).then(res => {
                var data=res.data;
                this.tabData=data
                this.total=res.total
                this.tabLoading=false
            }).catch((err=>{
                this.tabLoading=false
                this.$Message.error(error.response.data.message);
            })) 
        },

        changePage(val){
            this.listQuery.page=val
            this.getList()
        },
        changeLimit(val){
            this.listQuery.limit=val
            this.getList()
        },
       
       
        // 添加，编辑分组
        addGrouping(id){
            console.log(id)
            if(id!=='isAdd'){
                this.isTitle='修改分组'
                this.isEditorGroupingId=id
                this.apiDetailsGrouping(id)
            }else{
                this.isTitle='添加分组'
                this.isEditorGroupingId=''
                this.addGroupingForm.name=''
                this.addGroupingForm.sort=''
                this.addGroupingForm.remark=''
                
                this.showAddGrouping=true
            }
        },   
        // 确认
        handleSubmit (name,isTitle) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    switch(name){
                        case 'addGroupingForm':
                            if(isTitle=='添加分组'){
                                this.apiAddGrouping()
                            }else if(isTitle=='修改分组'){
                                this.apiEditorGrouping()
                            }
                        break;
                    }
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        // 取消
        handleReset (name) {
            this.$refs[name].resetFields();
            switch(name){
                case 'addGroupingForm':
                    this.showAddGrouping=false
                break;
            }
        },
        //限制正整数
        check_num(){
            var sort = this.addGroupingForm.sort;
            sort = sort.replace(/[^\d]/g, ''); 
            if (sort.indexOf('.') < 0 && sort != '') {
                sort = parseInt(sort);
            }
            this.addGroupingForm.sort = sort.toString();
        }
    }
}
</script>
<style>
.mr-t-10{
    margin-top: 10px;
}
.content{

}
.search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
.search_bar_item{
    /* text-align: center; */
    margin: 4px;
  }
.other_search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
 
.table_wrap{
    margin: 12px 12px 12px 0px;
}
.ivu-btn-icon-only {
    margin-left: 4px; 
    padding: 0px !important;
    font-size: 18px!important;
}
.ivu-table-cell {
    white-space: pre-line!important;
}
.ivu-drawer-header-inner {
    font-size: 20px!important;
}
.table_tip{
    margin: 0 0 10px 0px;
}
.demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
    z-index: 10;
}
.user_info_wrap{
    display: flex;
    justify-content:space-between;
    flex-direction:row;
    flex-wrap: wrap;
    height:40px;
    color: #464c5b;
    font-weight: 600;
    font-size: 14px;
    line-height: 40px;
    background: #f8f8f9;
    margin:10px 0 ;
}
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.vertical-center-modal  .ivu-modal{
    top: 0;
}
.modal_title{
    text-align: center;
}
.modal_text{
    color:red;
    text-align:center;
    margin-bottom:16px
}
.user_info_text_wrap{
    height: 46px;
    padding-top: 10px;
    padding-left: 32px;
    /* line-height: 56px; */

    /* padding: 10px; */
}
.opertionBtn{
    margin-bottom:20px;
    display:flex;
    display: -webkit-flex;
    align-items: center
}
.opertionBtn .item{
    margin-right: 5px
}
.mb-10{
    margin-bottom: 10px
}
</style>


// WEBPACK FOOTER //
// src/pages/Crm/CrmSetting/groupingManagement.vue